export default __webpack_public_path__ + "static/media/v2_277.3e61ba36.png";